export const OFFICE_NOT_SUPPORTED = "Office does not support this lead type";

export const PORTAL_NOT_SUPPORTED =
  "Portals you selected do not generate leads of this type.";
